import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';

import ggCategory from 'ggApp/modules/category';
import { productWidgetList, widgetListProducts } from 'ggApp/modules/productWidget/selectors';
import { withListEventHandlers } from 'ggApp/modules/tracking/hocs/withListEventHandlers';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import ggTranslator from 'ggApp/modules/translator';
import { getProductWidgets } from 'ggApp/modules/productWidget/actions';
import {
    CfHomePage,
    getPageFromCurrentStore as getPageAction,
    contentfulPage as contentfulPageSelector,
} from 'ggApp/modules/contentful';
import withDependencies, { priorityOfCall } from 'ggApp/shared/hocs/withDependencies';
import { initDone as initDoneSelector } from 'ggApp/modules/init/selectors';
import { isLoggedIn as isLoggedInSelector } from 'ggApp/modules/auth/selectors';
import { redirectus } from 'ggApp/modules/router/actions';

import { Home } from './Home';
import {
    categoriesWidgetOnHomepageEnabled as categoriesWidgetOnHomepageEnabledSelector,
    categoriesWidgetRedesignEnabled as categoriesWidgetRedesignEnabledSelector,
} from '../../../modules/featureFlag';

const enhance = compose(
    withDependencies([getProductWidgets], priorityOfCall.REGULAR),
    withDependencies([getPageAction(CfHomePage(false))], priorityOfCall.REGULAR),
    withListEventHandlers({
        productImpressionCallbacks: ['homePage', widgetListProducts],
    }),
    connect(
        createStructuredSelector({
            categoriesWidgetOnHomepageEnabled: categoriesWidgetOnHomepageEnabledSelector,
            categoriesWidgetRedesignEnabled: categoriesWidgetRedesignEnabledSelector,
            widgetList: productWidgetList,
            categoryList: ggCategory.selectors.list,
            translations: ggTranslator.selectors.keys,
            storeActive: activeStoreSelector,
            homePageContent: contentfulPageSelector(CfHomePage),
            widgetListProducts,
            initDone: initDoneSelector,
            isLoggedIn: isLoggedInSelector,
        }),
        (dispatch) => ({
            redirectus: bindActionCreators(redirectus, dispatch),
        }),
    ),
);

export default enhance(Home);
